module.exports = __webpack_public_path__ + "img/pingan.d087d551.png";